

















import { Component, Prop, Vue } from 'vue-property-decorator'
import List from './List.vue'
import gql from 'graphql-tag'

@Component({
  components: {
    List
  }
})
export default class Seed extends Vue {
  @Prop() private id!: number;
  seedQuery = gql`query Seed($id: Int!) {
    seed(id: $id) {
      name,
      description,
      type,
      user {
        name
      }
    }
  }`
}
